import styled from '@eduzz/houston-styles';

export const Container = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.xs};

  svg:nth-child(1) {
    font-size: ${({ theme }) => theme.font.size.md};
  }

  h3:nth-child(1) {
    font-size: 1.125rem;
    margin: 0 0 0.5rem 0;
    text-transform: uppercase;
  }
`;
